import { render, staticRenderFns } from "./AnotationMessage.vue?vue&type=template&id=620227d1&scoped=true&"
import script from "./AnotationMessage.vue?vue&type=script&lang=js&"
export * from "./AnotationMessage.vue?vue&type=script&lang=js&"
import style0 from "./AnotationMessage.vue?vue&type=style&index=0&id=620227d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620227d1",
  null
  
)

export default component.exports